export default defineNuxtPlugin((nuxtApp) => {
  const { PARTNERO_PROGRAM, PARTNERO_COOKIE_MAX_AGE } = nuxtApp.$config.public

  if (!PARTNERO_PROGRAM) {
    return
  }

  const { loadScript, addServiceKey } = useHelpers()

  nuxtApp.hook('app:mounted', () => {
    addServiceKey('PARTNERO_PROGRAM', PARTNERO_PROGRAM)

    loadScript('/scripts/partnero.js', true, true, function () {
      nuxtApp.provide('partnero', window.po)

      const route = useRoute()
      const techMaps = useTech().techsMap
      const { redirect, friend } = route.query

      if (techMaps[route.name] && redirect && friend) {
        setTimeout(() => navigateTo(redirect, { external: true }), 1000)
      }
    })
  })

  addRouteMiddleware('partnero', (to, from) => {
    if (import.meta.server) return

    const maxAge = PARTNERO_COOKIE_MAX_AGE || 60 * 60 * 24 * 30 // default 30 days

    const partneroPartner = useCookie('partnero_partner', { maxAge })
    const partneroReferral = useCookie('partnero_referral', { maxAge })

    const url = new URL(window.location.href)

    if (to.query.friend) {
      partneroPartner.value = to.query.friend
      // use url with only friend query for partnero tracking
      partneroReferral.value = (url.origin + url.pathname + `?friend=${to.query.friend}`).replace('/?', '?')
    }
  }, {
    global: true
  })
})
